import { withSvgIcon } from './withSvgIcon';

export const Analytics = withSvgIcon(
  <>
    <path
      d="M13.5 5C13.5 4.44772 13.9477 4 14.5 4H19C19.5523 4 20 4.44772 20 5V9.5C20 10.0523 19.5523 10.5 19 10.5H14.5C13.9477 10.5 13.5 10.0523 13.5 9.5V5Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M13.5 14.5C13.5 13.9477 13.9477 13.5 14.5 13.5H19C19.5523 13.5 20 13.9477 20 14.5V19C20 19.5523 19.5523 20 19 20H14.5C13.9477 20 13.5 19.5523 13.5 19V14.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M4 5C4 4.44772 4.44772 4 5 4H9.5C10.0523 4 10.5 4.44772 10.5 5V19C10.5 19.5523 10.0523 20 9.5 20H5C4.44772 20 4 19.5523 4 19V5Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
